import { memo } from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { inspectionLogger, getStepName } from 'utils/inspectionLogger';
import { useProject } from 'hooks/useProject';
import useInspection from 'hooks/useInspection';
import { useAppDispatch } from 'store';
import { postInspectionClickLogs } from 'store/inspection/inspectionSlice';

interface IGuideAgreementProps {
  agreement: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
function GuideAgreement({ agreement, handleChange }: IGuideAgreementProps): JSX.Element {
  const dispatch = useAppDispatch();
  const { urlProjectId, urlPartCode } = useProject();
  const { inspectionDetail } = useInspection();

  const handleAgreementChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    
    // 먼저 체크박스 상태 변경 (UI 반응성 확보)
    handleChange(event);
    
    // 로그 전송은 비동기로 처리 (UI 블로킹 방지)
    if (urlProjectId && urlPartCode && inspectionDetail.id) {
      inspectionLogger.logClick({
        projectId: urlProjectId,
        partCode: urlPartCode,
        inspectionId: inspectionDetail.id,
        step: '1' as const,
        stepName: getStepName('1'),
        actionType: 'agreement_click',
        agreementLevel: isChecked ? ('AA' as const) : undefined,
        agreementLevelName: isChecked ? '동의함' : undefined,
      });

      // 비동기로 전송 (await 없이 백그라운드에서 실행)
      inspectionLogger.flush().then((pendingLogs) => {
        if (pendingLogs.length > 0) {
          dispatch(postInspectionClickLogs({ projectId: urlProjectId, logs: pendingLogs }))
            .unwrap()
            .then(() => {
              console.log(`✅ 클릭 로그 ${pendingLogs.length}개 전송 완료`);
            })
            .catch((error) => {
              console.error('❌ 클릭 로그 전송 실패:', error);
            });
        }
      });
    }
  };

  return (
    <Box sx={{ mt: { xs: '10px', sm: '20px' } }}>
      <FormControlLabel
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiFormControlLabel-label': {
            typography: 's24w800',
            fontSize: { xs: '1.2rem', sm: '2rem' },
          },
        }}
        control={<Checkbox checked={agreement} onChange={handleAgreementChange} name="agreement" />}
        label="확인했습니다. 진단평가 응시를 시작하겠습니다."
      />
    </Box>
  );
}

export default memo(GuideAgreement);
